// extracted by mini-css-extract-plugin
module.exports = {"wrapper__container":"index_wrapper__container__edqSV","wrapper__default":"index_wrapper__default__i2S8N","wrapper__title":"index_wrapper__title__tBRpw","roll":"index_roll__wABfM"};